import { Button, Checkbox, FormControlLabel, TextField } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { Automation } from "services/admin/automationsService";

interface AutomationNameFormProps {
  automation: Automation;
  onSubmit: (data: any) => void;
}
export const AutomationNameForm = ({ automation, onSubmit }: AutomationNameFormProps) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    formState: { isValid },
    control,
  } = useForm({
    defaultValues: {
      name: automation.name,
      aiEnabled: automation.aiEnabled,
    },
    mode: "onChange",
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="pt-2">
      <div className="mb-4">
        <TextField
          label="Название"
          required
          fullWidth
          {...register("name", {
            required: {
              message: "Название обязательно",
              value: true,
            },
          })}
        />
        {errors.name && <span className="text-red-500">{errors.name.message}</span>}
      </div>
      <div className="mb-4">
        {/* Работать без прерывания */}
        <FormControlLabel control={<Checkbox />} label="Работать без прерывания" />
        <p className="text-sm text-gray-500">
          Другие автоматизации не будут прерывать работу текущей, в том числе работу функции
          задержек.
        </p>
      </div>
      <div className="mb-4">
        {/* ИИ может отвечать на вопросы */}
        <Controller control={control} name="aiEnabled" render={({ field }) => {
          return <FormControlLabel control={<Checkbox {...field} checked={field.value} />} label="ИИ может отвечать на вопросы" />
        }} />
        <p className="text-sm text-gray-500">
          Если в сценарии нет подходящего ответа, AI автоматически ответит на вопрос
          клиента.
        </p>
      </div>
      <Button type="submit" variant="contained" color="primary" fullWidth disabled={!isValid}>
        Сохранить
      </Button>
    </form>
  );
};
